import { Button, ModalGeneric } from 'ypf-pas-general-ui-components';
import { Col, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

import styles from './DetailsEventsModal.module.scss';

const DetailsEventsModal = ({
  dataDetailsEventsModal,
  showDetailsEventsModal,
  handleShowDetailsEventsModal,
  titleModal
}) => (
  <ModalGeneric
    backdrop="static"
    infoModal
    onHide={() => handleShowDetailsEventsModal({ showModal: false })}
    show={showDetailsEventsModal}
    size="md"
    title={titleModal}
  >
    <>
      <div className={styles.contentScrollData}>
        <Row className="d-flex w-100" sm={12}>
          {dataDetailsEventsModal.details?.map((well, index) => (
            <>
              <div className="d-flex">
                <div className={styles.sectionModalTitle}>
                  Evento - Inicio: {well.inicioDelEvento} Cierre: {well.finDelEvento}
                </div>
              </div>
              <hr />
              <Row className="pb-4" key={`well-${well.nombrePozo}-${index + 1}`}>
                <Col>
                  <span className={styles.sectionModalTitle}>
                    {well.nombrePozo}
                    {'  '}
                    {well.nombreEvento}
                    {'  '}
                    {well.nombreEquipo}
                    {'  '}
                  </span>
                  <span className={styles.sectionModalSubtitle}>Operación</span>
                </Col>
                {well?.operaciones.length ? (
                  <Col className={styles.contentModal} sm={12}>
                    <Row className={styles.columnTitle}>
                      <Col sm={6}>Inicio</Col>
                      <Col sm={6}>Cierre</Col>
                    </Row>
                    {well?.operaciones.map((operation) => (
                      <div key={`operation-${operation.inicioDeLaOperacion}`}>
                        <Row className={styles.columnContentModal}>
                          <Col sm={6}>
                            {operation.inicioDeLaOperacion.length
                              ? operation.inicioDeLaOperacion
                              : '--'}
                          </Col>
                          <Col sm={6}>
                            {operation.finDeLaOperacion.length ? operation.finDeLaOperacion : '--'}
                          </Col>
                        </Row>
                        <div className={styles.liner} />
                      </div>
                    ))}
                  </Col>
                ) : (
                  <Col className={styles.contentModal} sm={12}>
                    <Row className={styles.columnTitle}>
                      <Col sm={6}>Inicio</Col>
                      <Col sm={6}>Cierre</Col>
                    </Row>
                    <div>
                      <Row className={styles.columnContentModal}>
                        <Col sm={6}>--</Col>
                        <Col sm={6}>--</Col>
                      </Row>
                      <div className={styles.liner} />
                    </div>
                  </Col>
                )}
              </Row>
            </>
          ))}
        </Row>
      </div>
      <div className={styles.actionContainer}>
        <Button
          fontSizeLabel="14px"
          label="Salir"
          onClick={() => handleShowDetailsEventsModal({ showModal: false })}
          type="button"
          variant="primary"
          widthButton="60px"
        />
      </div>
    </>
  </ModalGeneric>
);

DetailsEventsModal.propTypes = {
  dataDetailsEventsModal: PropTypes.shape({
    ubicationName: PropTypes.string,
    typeEvent: PropTypes.string,
    equipmentName: PropTypes.string,
    ubicationStr: PropTypes.string,
    details: PropTypes.arrayOf(
      PropTypes.shape({
        pozos: PropTypes.arrayOf(PropTypes.shape({}))
      })
    )
  }),
  showDetailsEventsModal: PropTypes.bool,
  handleShowDetailsEventsModal: PropTypes.func,
  titleModal: PropTypes.string.isRequired
};
DetailsEventsModal.defaultProps = {
  dataDetailsEventsModal: {},
  showDetailsEventsModal: false,
  handleShowDetailsEventsModal: () => {}
};

export default DetailsEventsModal;
